import { create } from 'zustand'
import createSelectors from '../utils/createSelectors'

interface State {
  isLoading: boolean
}
interface Action {
  setIsLoading: (isLoading: State['isLoading']) => void
  reset: () => void
}

const baseStoreLoading = create<State & Action>((set) => ({
  isLoading: false,
  setIsLoading: (isLoading) => set(() => ({ isLoading })),
  reset: () =>
    set({
      isLoading: false
    })
}))

const useStoreLoading = createSelectors(baseStoreLoading)

export default useStoreLoading
